// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #7a838c;
  --secondary-color: #3498db;
  --accent-color: #e74c3c;
  --background-light: #f8f9fa;
}

.profile-container {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}

.profile-header {
  display: flex;
  gap: 2rem;
  align-items: center;
  padding-bottom: 2rem;
  border-bottom: 2px solid var(--background-light);
}

.avatar-uploader {
  position: relative;
  cursor: pointer;
}

.avatar-preview {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid var(--primary-color);
  transition: transform 0.3s ease;
}

.avatar-preview:hover {
  transform: scale(1.05);
}

.avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: var(--background-light);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: var(--primary-color);
}

.upload-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: rgba(255,255,255,0.3);
}

.form-tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.tab {
  padding: 1rem 2rem;
  border: none;
  background: none;
  font-size: 1.1rem;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab.active {
  color: var(--primary-color);
  border-bottom: 3px solid var(--secondary-color);
}

.form-content {
  display: grid;
  gap: 1.5rem;
  padding: 1rem;
  background: var(--background-light);
  border-radius: 12px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-field input,
.form-field textarea,
.form-field select {
  padding: 0.8rem;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-field input:focus,
.form-field textarea:focus {
  border-color: var(--secondary-color);
  outline: none;
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
}

.save-btn {
  background: var(--secondary-color);
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.save-btn:hover {
  background: #2980b9;
}

.progress-section {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.progress-wrapper {
  width: 100px;
  height: 100px;
}

.progress-label {
  font-size: 1.1rem;
  color: #2c3e50;
  font-weight: 500;
}

/* Form Styles */
.form-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid #eee;
}

.tab {
  padding: 1rem 2rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1rem;
  color: #666;
  transition: all 0.3s ease;
  border-radius: 8px 8px 0 0;
}

.tab.active {
  background: #f8f9fa;
  color: #2c3e50;
  font-weight: 500;
  border-bottom: 3px solid #2196F3;
}

.form-content {
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 2rem;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-input {
  padding: 0.8rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-input:focus {
  border-color: #2196F3;
  outline: none;
  box-shadow: 0 0 0 2px rgba(33,150,243,0.2);
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
}

.save-btn {
  background: #2196F3;
  color: white;
  padding: 0.8rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.save-btn:hover {
  background: #1976D2;
}

.cancel-btn {
  background: #e0e0e0;
  color: #333;
  padding: 0.8rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.cancel-btn:hover {
  background: #bdbdbd;
}

.tabs-container {
  margin-top: 2rem;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
}

.tabs-nav {
  display: flex;
  background: #f8f9fa;
  border-bottom: 2px solid #e0e0e0;
}

.tab-button {
  flex: 1 1;
  padding: 1.2rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1rem;
  color: #666;
  transition: all 0.3s ease;
  position: relative;
}

.tab-button.active {
  border-color: #3498db;
  background: rgba(52, 152, 219, 0.1);
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: #2196F3;
}

.tab-content {
  padding: 2rem;
  background: #fff;
}

.tab-button:hover {
  background: rgba(52, 152, 219, 0.05);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.info-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.info-value {
  color: #555;
  word-break: break-word;
  line-height: 1.5;
}

.document-section h3 {
  color: #2c3e50;
  margin: 2rem 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #eee;
}

.membership-actions {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid #eee;
}

.join-button {
  background: #2196F3;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s ease;
}

.join-button:hover:not(.disabled) {
  background: #1976D2;
}

.join-button.disabled {
  background: #bdbdbd;
  cursor: not-allowed;
}

.status-message {
  padding: 1.5rem;
  background: #fff3cd;
  color: #856404;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.form-notice {
  color: #d32f2f;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  background: #f8f9fa;
}

.edit-profile-button {
  background: #27ae60;
  color: white;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  margin-left: auto;
}

.edit-profile-button:hover {
  background: #219a52;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

/* Обновленные стили для навигации */
.tabs-nav {
  display: flex;
  flex-grow: 1;
}

.tab-button {
  flex: 1 1;
  max-width: 200px;
}

/* Organization Tab Styles */
.organization-info {
  padding: 20px;
}

.status-section {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.status-message {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.status-message.success {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-message.warning {
  background-color: #fff3e0;
  color: #ef6c00;
}

.revoke-button {
  background-color: #ef5350;
  color: white;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.revoke-button:hover {
  background-color: #d32f2f;
}

.join-section {
  margin-top: 2rem;
}

@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    text-align: center;
  }

  .tabs-header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .edit-profile-button {
    width: 100%;
    margin-top: 1rem;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
  .tabs-nav {
    width: 100%;
  }

  .tab-button {
    max-width: none;
    width: 25%;
    padding: 0.8rem;
    font-size: 0.9rem;
  }

  .tab-content {
    padding: 1rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
  .status-message {
    font-size: 0.9rem;
    padding: 0.8rem;
  }

  .revoke-button {
    width: 100%;
    padding: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProfilePage/ProfilePage.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[":root {\r\n  --primary-color: #7a838c;\r\n  --secondary-color: #3498db;\r\n  --accent-color: #e74c3c;\r\n  --background-light: #f8f9fa;\r\n}\r\n\r\n.profile-container {\r\n  max-width: 1200px;\r\n  margin: 2rem auto;\r\n  padding: 2rem;\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 24px rgba(0,0,0,0.1);\r\n}\r\n\r\n.profile-header {\r\n  display: flex;\r\n  gap: 2rem;\r\n  align-items: center;\r\n  padding-bottom: 2rem;\r\n  border-bottom: 2px solid var(--background-light);\r\n}\r\n\r\n.avatar-uploader {\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.avatar-preview {\r\n  width: 150px;\r\n  height: 150px;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n  border: 4px solid var(--primary-color);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.avatar-preview:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.avatar-preview img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.avatar-placeholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: var(--background-light);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 3rem;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.upload-progress {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: rgba(255,255,255,0.3);\r\n}\r\n\r\n.form-tabs {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.tab {\r\n  padding: 1rem 2rem;\r\n  border: none;\r\n  background: none;\r\n  font-size: 1.1rem;\r\n  color: #666;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.tab.active {\r\n  color: var(--primary-color);\r\n  border-bottom: 3px solid var(--secondary-color);\r\n}\r\n\r\n.form-content {\r\n  display: grid;\r\n  gap: 1.5rem;\r\n  padding: 1rem;\r\n  background: var(--background-light);\r\n  border-radius: 12px;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 1.5rem;\r\n}\r\n\r\n.form-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.form-field input,\r\n.form-field textarea,\r\n.form-field select {\r\n  padding: 0.8rem;\r\n  border: 2px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.form-field input:focus,\r\n.form-field textarea:focus {\r\n  border-color: var(--secondary-color);\r\n  outline: none;\r\n}\r\n\r\n.form-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: flex-end;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.save-btn {\r\n  background: var(--secondary-color);\r\n  color: white;\r\n  padding: 1rem 2rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.save-btn:hover {\r\n  background: #2980b9;\r\n}\r\n\r\n.progress-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n  padding: 1.5rem;\r\n  background: #f8f9fa;\r\n  border-radius: 12px;\r\n}\r\n\r\n.progress-wrapper {\r\n  width: 100px;\r\n  height: 100px;\r\n}\r\n\r\n.progress-label {\r\n  font-size: 1.1rem;\r\n  color: #2c3e50;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Form Styles */\r\n.form-tabs {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  margin-bottom: 2rem;\r\n  border-bottom: 2px solid #eee;\r\n}\r\n\r\n.tab {\r\n  padding: 1rem 2rem;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  color: #666;\r\n  transition: all 0.3s ease;\r\n  border-radius: 8px 8px 0 0;\r\n}\r\n\r\n.tab.active {\r\n  background: #f8f9fa;\r\n  color: #2c3e50;\r\n  font-weight: 500;\r\n  border-bottom: 3px solid #2196F3;\r\n}\r\n\r\n.form-content {\r\n  padding: 1.5rem;\r\n  background: #f8f9fa;\r\n  border-radius: 12px;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.form-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.form-input {\r\n  padding: 0.8rem 1rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.form-input:focus {\r\n  border-color: #2196F3;\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(33,150,243,0.2);\r\n}\r\n\r\n.form-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: flex-end;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.save-btn {\r\n  background: #2196F3;\r\n  color: white;\r\n  padding: 0.8rem 2rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.save-btn:hover {\r\n  background: #1976D2;\r\n}\r\n\r\n.cancel-btn {\r\n  background: #e0e0e0;\r\n  color: #333;\r\n  padding: 0.8rem 2rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.cancel-btn:hover {\r\n  background: #bdbdbd;\r\n}\r\n\r\n.tabs-container {\r\n  margin-top: 2rem;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.tabs-nav {\r\n  display: flex;\r\n  background: #f8f9fa;\r\n  border-bottom: 2px solid #e0e0e0;\r\n}\r\n\r\n.tab-button {\r\n  flex: 1;\r\n  padding: 1.2rem;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  color: #666;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n}\r\n\r\n.tab-button.active {\r\n  border-color: #3498db;\r\n  background: rgba(52, 152, 219, 0.1);\r\n}\r\n\r\n.tab-button.active::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -2px;\r\n  left: 0;\r\n  right: 0;\r\n  height: 2px;\r\n  background: #2196F3;\r\n}\r\n\r\n.tab-content {\r\n  padding: 2rem;\r\n  background: #fff;\r\n}\r\n\r\n.tab-button:hover {\r\n  background: rgba(52, 152, 219, 0.05);\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n  gap: 1.5rem;\r\n}\r\n\r\n.info-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 1rem;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n}\r\n\r\n.info-label {\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.info-value {\r\n  color: #555;\r\n  word-break: break-word;\r\n  line-height: 1.5;\r\n}\r\n\r\n.document-section h3 {\r\n  color: #2c3e50;\r\n  margin: 2rem 0 1rem;\r\n  padding-bottom: 0.5rem;\r\n  border-bottom: 2px solid #eee;\r\n}\r\n\r\n.membership-actions {\r\n  margin-top: 2rem;\r\n  padding-top: 2rem;\r\n  border-top: 2px solid #eee;\r\n}\r\n\r\n.join-button {\r\n  background: #2196F3;\r\n  color: white;\r\n  padding: 1rem 2rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.join-button:hover:not(.disabled) {\r\n  background: #1976D2;\r\n}\r\n\r\n.join-button.disabled {\r\n  background: #bdbdbd;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.status-message {\r\n  padding: 1.5rem;\r\n  background: #fff3cd;\r\n  color: #856404;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8rem;\r\n}\r\n\r\n.form-notice {\r\n  color: #d32f2f;\r\n  margin-top: 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.tabs-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 1rem;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.edit-profile-button {\r\n  background: #27ae60;\r\n  color: white;\r\n  padding: 0.8rem 1.5rem;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.3s ease;\r\n  margin-left: auto;\r\n}\r\n\r\n.edit-profile-button:hover {\r\n  background: #219a52;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\r\n}\r\n\r\n/* Обновленные стили для навигации */\r\n.tabs-nav {\r\n  display: flex;\r\n  flex-grow: 1;\r\n}\r\n\r\n.tab-button {\r\n  flex: 1;\r\n  max-width: 200px;\r\n}\r\n\r\n/* Organization Tab Styles */\r\n.organization-info {\r\n  padding: 20px;\r\n}\r\n\r\n.status-section {\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n}\r\n\r\n.status-message {\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.status-message.success {\r\n  background-color: #e8f5e9;\r\n  color: #2e7d32;\r\n}\r\n\r\n.status-message.warning {\r\n  background-color: #fff3e0;\r\n  color: #ef6c00;\r\n}\r\n\r\n.revoke-button {\r\n  background-color: #ef5350;\r\n  color: white;\r\n  padding: 0.8rem 1.5rem;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 1rem;\r\n}\r\n\r\n.revoke-button:hover {\r\n  background-color: #d32f2f;\r\n}\r\n\r\n.join-section {\r\n  margin-top: 2rem;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .profile-header {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .tabs-header {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .edit-profile-button {\r\n    width: 100%;\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .tabs-nav {\r\n    width: 100%;\r\n  }\r\n\r\n  .tab-button {\r\n    max-width: none;\r\n    width: 25%;\r\n    padding: 0.8rem;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .tab-content {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .info-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .status-message {\r\n    font-size: 0.9rem;\r\n    padding: 0.8rem;\r\n  }\r\n\r\n  .revoke-button {\r\n    width: 100%;\r\n    padding: 0.8rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
